import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, Fragment as _Fragment, resolveDirective as _resolveDirective, withDirectives as _withDirectives, renderList as _renderList, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-07c6b469"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tier-card--heading-container" }
const _hoisted_2 = { class: "tier-card--header d-flex" }
const _hoisted_3 = ["src"]
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "tier-card--description" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Number of Receivers")
], -1))
const _hoisted_7 = { class: "tier-card__update-row" }
const _hoisted_8 = { class: "tier-card__update-row-total" }
const _hoisted_9 = { class: "tier-card__frequency-choice" }
const _hoisted_10 = { class: "tier-card__update-row-total" }
const _hoisted_11 = { class: "tier-card__total_price" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Total Price", -1))
const _hoisted_13 = { class: "tier-card__update-row" }
const _hoisted_14 = { key: 0 }
const _hoisted_15 = { key: 1 }
const _hoisted_16 = { key: 2 }
const _hoisted_17 = { key: 3 }
const _hoisted_18 = { class: "w-100" }
const _hoisted_19 = { class: "tier-card__update-row tier-card--compare-button" }
const _hoisted_20 = {
  key: 1,
  class: "tier-card__update-row"
}
const _hoisted_21 = { class: "tier-card__frequency-choice" }
const _hoisted_22 = { class: "tier-card--list" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M5 20v-1a7 7 0 017-7v0a7 7 0 017 7v1M12 12a4 4 0 100-8 4 4 0 000 8z",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })
], -1))
const _hoisted_24 = {
  key: 0,
  class: "tier-card__error-icon",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M12 7v6M12 17.01l.01-.011M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10z",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1))
const _hoisted_26 = [
  _hoisted_25
]
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M7 21h10",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }),
  /*#__PURE__*/_createElementVNode("path", { d: "M2 16.4V3.6a.6.6 0 01.6-.6h18.8a.6.6 0 01.6.6v12.8a.6.6 0 01-.6.6H2.6a.6.6 0 01-.6-.6z" })
], -1))
const _hoisted_28 = {
  key: 0,
  class: "tier-card__error-icon",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M12 7v6M12 17.01l.01-.011M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10z",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1))
const _hoisted_30 = [
  _hoisted_29
]
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M5 12v6s0 3 7 3 7-3 7-3v-6" }),
  /*#__PURE__*/_createElementVNode("path", { d: "M5 6v6s0 3 7 3 7-3 7-3V6" }),
  /*#__PURE__*/_createElementVNode("path", { d: "M12 3c7 0 7 3 7 3s0 3-7 3-7-3-7-3 0-3 7-3z" })
], -1))
const _hoisted_32 = {
  key: 0,
  class: "tier-card__error-icon",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M12 7v6M12 17.01l.01-.011M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10z",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1))
const _hoisted_34 = [
  _hoisted_33
]
const _hoisted_35 = {
  key: 0,
  class: "tier-card__list-item-error"
}
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "tier-card__error-icon",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M12 7v6M12 17.01l.01-.011M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10z",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })
], -1))
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Feature usage prevents selecting this plan", -1))
const _hoisted_38 = [
  _hoisted_36,
  _hoisted_37
]
const _hoisted_39 = {
  key: 2,
  class: "mt-4"
}
const _hoisted_40 = { key: 0 }
const _hoisted_41 = {
  key: 1,
  class: "m-0"
}
const _hoisted_42 = {
  key: 2,
  class: "m-0"
}
const _hoisted_43 = { key: 0 }
const _hoisted_44 = { class: "mb-3" }
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Renewal date:", -1))
const _hoisted_46 = { class: "callout callout--no-max callout--danger mb-3" }
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "This update can only be made within 30 days of your renewal date. Please contact your Ditto representative for further assistance.", -1))
const _hoisted_48 = { key: 1 }
const _hoisted_49 = { class: "callout callout--warning" }
const _hoisted_50 = { class: "limits-callout" }
const _hoisted_51 = {
  key: 0,
  class: "mb-2"
}
const _hoisted_52 = { key: 1 }
const _hoisted_53 = {
  key: 0,
  class: "callout callout--no-max callout--warning mt-3"
}
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Daily price is not available for this plan.", -1))
const _hoisted_55 = { key: 2 }
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Update Summary", -1))
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Plan:", -1))
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Number of receivers:", -1))
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Total price:", -1))
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Renewal date:", -1))
const _hoisted_61 = { key: 0 }
const _hoisted_62 = { class: "callout callout--no-max callout--warning mt-3" }
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Daily price is not available for this plan.", -1))
const _hoisted_64 = { key: 1 }
const _hoisted_65 = {
  key: 0,
  class: "callout callout--no-max callout--danger mt-3"
}
const _hoisted_66 = {
  key: 1,
  class: "callout callout--no-max callout--warning mt-3"
}
const _hoisted_67 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "This update will be effective immediately.", -1))
const _hoisted_68 = { class: "dialog-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_el_radio_button = _resolveComponent("el-radio-button")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_Icon = _resolveComponent("Icon")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_SubscriptionPaymentModal = _resolveComponent("SubscriptionPaymentModal")!
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", {
      class: _normalizeClass({ 'tier-card__plan-details' : !_ctx.isPO })
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("h1", {
            class: _normalizeClass(["my-auto", {'tier-card__current-plan' : _ctx.isCurrentPlan }])
          }, _toDisplayString(_ctx.plan.name), 3),
          (_ctx.plan.name === 'Elite')
            ? (_openBlock(), _createElementBlock("img", {
                key: 0,
                class: "logo--2x-large ms-1 mb-0 me-0",
                src: require('../../assets/images/ditto-tier-logo-gold.png')
              }, null, 8, _hoisted_3))
            : _createCommentVNode("", true),
          (_ctx.plan.name === 'Premium')
            ? (_openBlock(), _createElementBlock("img", {
                key: 1,
                class: "logo--2x-large ms-1 mb-0 me-0",
                src: require('../../assets/images/ditto-tier-logo-gray.png')
              }, null, 8, _hoisted_4))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", {
          class: _normalizeClass(["tier-card--yearly-cost-dollars", {'tier-card__current-plan' : _ctx.isCurrentPlan }])
        }, [
          _createTextVNode("$" + _toDisplayString(_ctx.planPrice), 1),
          _createElementVNode("span", null, " receiver/" + _toDisplayString(_ctx.billingFrequency), 1)
        ], 2),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("p", null, _toDisplayString(_ctx.planDescription), 1)
        ])
      ]),
      (!_ctx.isPO && _ctx.hasBilling)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _hoisted_6,
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_component_el_input_number, {
                min: 1,
                max: 5000,
                modelValue: _ctx.receiverCount,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.receiverCount) = $event)),
                class: "tier-card__room-counter"
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createVNode(_component_el_radio_group, {
                  modelValue: _ctx.frequencySelection,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.frequencySelection) = $event)),
                  size: "large",
                  class: "tier-card__frequency-choice-group"
                }, {
                  default: _withCtx(() => [
                    (_ctx.hasDailyPrice)
                      ? (_openBlock(), _createBlock(_component_el_radio_button, {
                          key: 0,
                          label: "day",
                          class: "tier-card__frequency-choice-button"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Daily")
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    _createVNode(_component_el_radio_button, {
                      label: "month",
                      class: "tier-card__frequency-choice-button"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Monthly")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_radio_button, {
                      label: "year",
                      class: "tier-card__frequency-choice-button"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Yearly "),
                        _createElementVNode("span", {
                          class: _normalizeClass({'tier-card__discount-tag-white' : _ctx.frequencySelection == 'year', 'tier-card__discount-tag' : _ctx.frequencySelection != 'year'})
                        }, _toDisplayString(_ctx.calculatedYearlyDiscount), 3)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ])
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _hoisted_12,
                _createElementVNode("strong", null, "$" + _toDisplayString(_ctx.totalPrice), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_13, [
              _createVNode(_component_el_tooltip, {
                placement: "top",
                "show-after": 0,
                "hide-after": 0,
                disabled: _ctx.allowChange && _ctx.receiverCountAllowed && _ctx.allowPurchaseOrChange,
                "popper-class": "tier-card__tooltip"
              }, {
                content: _withCtx(() => [
                  (!_ctx.allowChange)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_14, "Complete required account changes before continuing. "))
                    : _createCommentVNode("", true),
                  (!_ctx.receiverCountAllowed && !_ctx.lessThanActiveReceivers)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_15, "Number of receivers exceeds plan limit. "))
                    : _createCommentVNode("", true),
                  (!_ctx.receiverCountAllowed && _ctx.lessThanActiveReceivers)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_16, "Number of receivers can't be less than active receivers."))
                    : _createCommentVNode("", true),
                  (!_ctx.allowPurchaseOrChange)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_17, "Please edit your payment information before making any changes. "))
                    : _createCommentVNode("", true)
                ]),
                default: _withCtx(() => [
                  _createElementVNode("span", _hoisted_18, [
                    (_ctx.isUpdate)
                      ? (_openBlock(), _createBlock(_component_el_button, {
                          key: 0,
                          class: "tier-card--purchase-button",
                          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onUpdateClick(true))),
                          disabled: _ctx.noChanges || !_ctx.receiverCountAllowed || !_ctx.allowPurchaseOrChange,
                          type: "primary"
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("span", null, _toDisplayString(_ctx.updateButtonText), 1)
                          ]),
                          _: 1
                        }, 8, ["disabled"]))
                      : (!_ctx.allowChange && !_ctx.isUpdate)
                        ? (_openBlock(), _createBlock(_component_el_button, {
                            key: 1,
                            class: "tier-card--purchase-button",
                            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.onUpdateClick(true))),
                            disabled: _ctx.noChanges || !_ctx.receiverCountAllowed || !_ctx.allowPurchaseOrChange,
                            type: "primary"
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("span", null, "Purchase " + _toDisplayString(_ctx.plan.name), 1)
                            ]),
                            _: 1
                          }, 8, ["disabled"]))
                        : (_openBlock(), _createBlock(_component_el_button, {
                            key: 2,
                            class: "tier-card--purchase-button",
                            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.onUpdateClick(false))),
                            disabled: !_ctx.receiverCountAllowed || !_ctx.allowPurchaseOrChange,
                            type: "primary"
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("span", null, "Purchase " + _toDisplayString(_ctx.plan.name), 1)
                            ]),
                            _: 1
                          }, 8, ["disabled"]))
                  ])
                ]),
                _: 1
              }, 8, ["disabled"])
            ]),
            _createElementVNode("div", _hoisted_19, [
              _createVNode(_component_el_button, {
                class: "tier-card--compare-button-text",
                type: "text",
                link: "",
                text: "plain",
                onClick: _ctx.goToComparePlans
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Compare plans")
                ]),
                _: 1
              }, 8, ["onClick"])
            ])
          ], 64))
        : (_openBlock(), _createElementBlock("div", _hoisted_20, [
            _createElementVNode("div", _hoisted_21, [
              _createVNode(_component_el_radio_group, {
                modelValue: _ctx.frequencySelection,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.frequencySelection) = $event)),
                size: "large",
                class: "tier-card__frequency-choice-group"
              }, {
                default: _withCtx(() => [
                  (_ctx.hasDailyPrice)
                    ? (_openBlock(), _createBlock(_component_el_radio_button, {
                        key: 0,
                        label: "day",
                        class: "tier-card__frequency-choice-button"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Daily")
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  _createVNode(_component_el_radio_button, {
                    label: "month",
                    class: "tier-card__frequency-choice-button"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Monthly")
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_radio_button, {
                    label: "year",
                    class: "tier-card__frequency-choice-button"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Yearly "),
                      _createElementVNode("span", {
                        class: _normalizeClass({'tier-card__discount-tag-white' : _ctx.frequencySelection == 'year', 'tier-card__discount-tag' : _ctx.frequencySelection != 'year'})
                      }, _toDisplayString(_ctx.calculatedYearlyDiscount), 3)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["modelValue"])
            ])
          ])),
      _createElementVNode("ul", _hoisted_22, [
        _createElementVNode("li", null, [
          _createElementVNode("strong", null, _toDisplayString(_ctx.plan.name), 1),
          _createTextVNode(" includes up to:")
        ]),
        _createVNode(_component_el_tooltip, {
          disabled: !_ctx.amountOverUsersQuota,
          placement: "top",
          "show-after": 0,
          "hide-after": 0,
          width: 300,
          "popper-class": "tier-card__tooltip"
        }, {
          content: _withCtx(() => [
            _createTextVNode(" You are currently "),
            _createElementVNode("strong", null, _toDisplayString(_ctx.amountOverUsersQuota), 1),
            _createTextVNode(" users over quota. Please remove users to select this plan. ")
          ]),
          default: _withCtx(() => [
            _createElementVNode("li", {
              class: _normalizeClass({ 'tier-card__list-item-error' : _ctx.amountOverUsersQuota })
            }, [
              _hoisted_23,
              _createElementVNode("span", null, _toDisplayString(_ctx.planUserLimit), 1),
              (_ctx.amountOverUsersQuota)
                ? (_openBlock(), _createElementBlock("svg", _hoisted_24, _hoisted_26))
                : _createCommentVNode("", true)
            ], 2)
          ]),
          _: 1
        }, 8, ["disabled"]),
        _createVNode(_component_el_tooltip, {
          disabled: !_ctx.amountOverReceiversQuota,
          placement: "top",
          "show-after": 0,
          "hide-after": 0,
          "popper-class": "tier-card__tooltip"
        }, {
          content: _withCtx(() => [
            _createTextVNode(" You are currently "),
            _createElementVNode("strong", null, _toDisplayString(_ctx.amountOverReceiversQuota), 1),
            _createTextVNode(" receivers over quota. Please remove receivers to select this plan. ")
          ]),
          default: _withCtx(() => [
            _createElementVNode("li", {
              class: _normalizeClass({ 'tier-card__list-item-error' : _ctx.amountOverReceiversQuota })
            }, [
              _hoisted_27,
              _createElementVNode("span", null, _toDisplayString(_ctx.planReceiverLimit), 1),
              (_ctx.amountOverReceiversQuota)
                ? (_openBlock(), _createElementBlock("svg", _hoisted_28, _hoisted_30))
                : _createCommentVNode("", true)
            ], 2)
          ]),
          _: 1
        }, 8, ["disabled"]),
        _createVNode(_component_el_tooltip, {
          disabled: !_ctx.amountOverStorageQuota,
          placement: "top",
          "show-after": 0,
          "hide-after": 0,
          "popper-class": "tier-card__tooltip"
        }, {
          content: _withCtx(() => [
            _createTextVNode(" You are currently "),
            _createElementVNode("strong", null, _toDisplayString(_ctx.amountOverStorageQuota) + " " + _toDisplayString(_ctx.restrictionMemoryUnitCheck() ? 'MB' : 'GB'), 1),
            _createTextVNode(" user over storage quota. Please clear up memory to select this plan. ")
          ]),
          default: _withCtx(() => [
            _createElementVNode("li", {
              class: _normalizeClass({ 'tier-card__list-item-error' : _ctx.amountOverStorageQuota })
            }, [
              _hoisted_31,
              _createElementVNode("span", null, _toDisplayString(_ctx.planStorageLimit), 1),
              (_ctx.amountOverStorageQuota)
                ? (_openBlock(), _createElementBlock("svg", _hoisted_32, _hoisted_34))
                : _createCommentVNode("", true)
            ], 2)
          ]),
          _: 1
        }, 8, ["disabled"]),
        (_ctx.featuresBlockChange)
          ? (_openBlock(), _createElementBlock("li", _hoisted_35, _hoisted_38))
          : _createCommentVNode("", true)
      ]),
      (_ctx.plan.name === 'Elite')
        ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
            _createVNode(_component_el_button, {
              class: "tier-card--compare-button-text text-decoration-underline",
              type: "text",
              link: "",
              text: "plain",
              onClick: _ctx.moreHelpClick
            }, {
              default: _withCtx(() => [
                _createTextVNode("Need more?")
              ]),
              _: 1
            }, 8, ["onClick"])
          ]))
        : _createCommentVNode("", true)
    ], 2),
    _createVNode(_component_el_dialog, {
      modelValue: _ctx.isUpdateModalVisible,
      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.isUpdateModalVisible) = $event)),
      onClose: _cache[8] || (_cache[8] = ($event: any) => (_ctx.isUpdateModalVisible = false)),
      class: "subscriptionModal"
    }, {
      title: _withCtx(() => [
        (_ctx.isDowngrade && !_ctx.isInPlanChangeWindow)
          ? (_openBlock(), _createElementBlock("h2", _hoisted_40, "Unable to Downgrade"))
          : (!_ctx.allowChange)
            ? (_openBlock(), _createElementBlock("h2", _hoisted_41, "Action Required"))
            : (_openBlock(), _createElementBlock("h2", _hoisted_42, "Confirm Subscription Update"))
      ]),
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_68, [
          _createVNode(_component_el_button, {
            onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.isUpdateModalVisible = false))
          }, {
            default: _withCtx(() => [
              _createTextVNode("Cancel")
            ]),
            _: 1
          }),
          (_ctx.allowChange && (_ctx.isInPlanChangeWindow || !_ctx.isDowngrade))
            ? _withDirectives((_openBlock(), _createBlock(_component_el_button, {
                key: 0,
                disabled: (_ctx.isDowngrade && !_ctx.isInPlanChangeWindow) || (_ctx.frequencySelection == 'day' && !_ctx.hasDailyPrice),
                type: "primary",
                onClick: _ctx.updateSubscription
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Update " + _toDisplayString(_ctx.allowChange && !_ctx.isDowngrade ? '& Charge' : ''), 1)
                ]),
                _: 1
              }, 8, ["disabled", "onClick"])), [
                [_directive_loading, _ctx.isUpdating || _ctx.isUpdateLoading]
              ])
            : _createCommentVNode("", true)
        ])
      ]),
      default: _withCtx(() => [
        (_ctx.isDowngrade && !_ctx.isInPlanChangeWindow)
          ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_43, [
              _createElementVNode("div", _hoisted_44, [
                _hoisted_45,
                _createTextVNode(" " + _toDisplayString(_ctx.expirationDate), 1)
              ]),
              _createElementVNode("div", _hoisted_46, [
                _createVNode(_component_Icon, {
                  class: "icon icon--x-large icon--danger",
                  icon: _ctx.mdiAlertCircleOutline
                }, null, 8, ["icon"]),
                _hoisted_47
              ])
            ])), [
              [_directive_loading, _ctx.isUpdateLoading]
            ])
          : (!_ctx.allowChange)
            ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
                _createElementVNode("div", _hoisted_49, [
                  _createVNode(_component_Icon, {
                    class: "icon icon--x-large",
                    icon: _ctx.mdiAlertCircleOutline
                  }, null, 8, ["icon"]),
                  _createElementVNode("div", _hoisted_50, [
                    _createElementVNode("p", null, [
                      _createTextVNode("Your account exceeds "),
                      _createElementVNode("strong", null, _toDisplayString(_ctx.plan.name), 1),
                      _createTextVNode(" plan limitations.")
                    ]),
                    (_ctx.limitsOverage && _ctx.limitsOverage.length > 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_51, [
                          _createElementVNode("span", null, [
                            _createTextVNode("The following limits prevent a downgrade to "),
                            _createElementVNode("strong", null, _toDisplayString(_ctx.plan.name), 1),
                            _createTextVNode(":")
                          ]),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.limitsOverage, (limit) => {
                            return (_openBlock(), _createElementBlock("ul", { key: limit }, [
                              _createElementVNode("li", null, _toDisplayString(limit), 1)
                            ]))
                          }), 128))
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.usedFeatures && _ctx.usedFeatures.length > 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_52, [
                          _createElementVNode("span", null, [
                            _createTextVNode("The following feature usage prevents a downgrade to "),
                            _createElementVNode("strong", null, _toDisplayString(_ctx.plan.name), 1),
                            _createTextVNode(":")
                          ]),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.usedFeatures, (feature) => {
                            return (_openBlock(), _createElementBlock("ul", { key: feature }, [
                              _createElementVNode("li", null, _toDisplayString(feature), 1)
                            ]))
                          }), 128))
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ]),
                (_ctx.frequencySelection == 'day' && !_ctx.hasDailyPrice)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_53, [
                      _createVNode(_component_Icon, {
                        class: "icon icon--x-large",
                        icon: _ctx.mdiAlertCircleOutline
                      }, null, 8, ["icon"]),
                      _hoisted_54
                    ]))
                  : _createCommentVNode("", true)
              ]))
            : _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_55, [
                _hoisted_56,
                _createElementVNode("ul", null, [
                  _createElementVNode("li", null, [
                    _hoisted_57,
                    _createTextVNode(" " + _toDisplayString(_ctx.plan.name), 1)
                  ]),
                  _createElementVNode("li", null, [
                    _hoisted_58,
                    _createTextVNode(" " + _toDisplayString(_ctx.receiverCount), 1)
                  ]),
                  _createElementVNode("li", null, [
                    _hoisted_59,
                    _createTextVNode(" $" + _toDisplayString(_ctx.totalPrice), 1)
                  ]),
                  _createElementVNode("li", null, [
                    _hoisted_60,
                    _createTextVNode(" " + _toDisplayString(_ctx.expirationDate), 1)
                  ])
                ]),
                (_ctx.frequencySelection == 'day' && !_ctx.hasDailyPrice)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_61, [
                      _createElementVNode("div", _hoisted_62, [
                        _createVNode(_component_Icon, {
                          class: "icon icon--x-large",
                          icon: _ctx.mdiAlertCircleOutline
                        }, null, 8, ["icon"]),
                        _hoisted_63
                      ])
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_64, [
                      (_ctx.allowChange && !_ctx.isDowngrade)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_65, [
                            _createVNode(_component_Icon, {
                              class: "icon icon--x-large icon--danger",
                              icon: _ctx.mdiAlertCircleOutline
                            }, null, 8, ["icon"]),
                            _createElementVNode("span", null, "Updating will result in an immediate charge of " + _toDisplayString(_ctx.newSubscriptionTotal) + ".", 1)
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.isDowngrade)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_66, [
                            _createVNode(_component_Icon, {
                              class: "icon icon--x-large",
                              icon: _ctx.mdiAlertCircleOutline
                            }, null, 8, ["icon"]),
                            _hoisted_67
                          ]))
                        : _createCommentVNode("", true)
                    ]))
              ])), [
                [_directive_loading, _ctx.isUpdateLoading]
              ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_SubscriptionPaymentModal, {
      modelValue: _ctx.isStartSubscriptionModalVisible,
      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.isStartSubscriptionModalVisible) = $event)),
      isUpdate: false,
      planName: _ctx.plan.name,
      planId: _ctx.plan.id,
      receiverCount: _ctx.receiverCount,
      totalPrice: _ctx.totalPrice,
      onModalClosed: _cache[10] || (_cache[10] = ($event: any) => (_ctx.isStartSubscriptionModalVisible = false)),
      onStartSubscription: _ctx.startSubscription
    }, null, 8, ["modelValue", "planName", "planId", "receiverCount", "totalPrice", "onStartSubscription"])
  ])), [
    [_directive_loading, _ctx.isLoading]
  ])
}